import script from "./CreationView.vue?vue&type=script&setup=true&lang=js"
export * from "./CreationView.vue?vue&type=script&setup=true&lang=js"

import "./CreationView.vue?vue&type=style&index=0&id=4f6e7678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6e7678"]])

export default __exports__